// extracted by mini-css-extract-plugin
export default {"wrap":"VH-z","subtitle":"WH-z","contentWrap":"XH-z","imgWrap":"YH-z","heading":"ZH-z","copy":"_H-z"};